import React, { useState } from "react";
import { useFormikContext } from "formik";
import CaretDown from "../../../../../assets/svg/icons/common/CaretDown";
import TextInput from "../../../../../components/form/text-input";
import useUserStore from "../../../../../stores/user";
import { getDefaultFees } from "../../../validation-schema";
import styles from "./style.module.scss";

const FeeDefaults = () => {
  const [open, setOpen] = useState(false);
  const organizationId = useUserStore((state) => state.organizationId);
  const { touched, handleBlur, values, errors, handleChange, setFieldValue } =
    useFormikContext();
  const defaultFees = getDefaultFees(organizationId);

  return (
    <div className={`${styles.card} ${open ? styles.open : ""}`}>
      <div className={styles.header} onClick={() => setOpen(!open)}>
        <CaretDown />
        <h6 className={styles.heading}>Other fee defaults</h6>
      </div>

      {open && (
        <div className={`${styles.body}`}>
          <TextInput
            label={"Setup Fee"}
            placeholder={defaultFees?.setup_fee?.default?.toFixed(2) || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"setup_fee"}
            name={"setup_fee"}
            value={values.setup_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.setup_fee}
            errored={errors.setup_fee}
            error={errors.setup_fee}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("setup_fee", e.target.rawValue);
              },
            }}
          />
          <TextInput
            label={"Monthly Access Fee"}
            placeholder={
              defaultFees?.monthly_access_fee?.default?.toFixed(2) || "0.00"
            }
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"monthly_access_fee"}
            name={"monthly_access_fee"}
            value={values.monthly_access_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.monthly_access_fee}
            errored={errors.monthly_access_fee}
            error={errors.monthly_access_fee}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("monthly_access_fee", e.target.rawValue);
              },
            }}
          />
          <TextInput
            label={"$100K Data Breach"}
            placeholder={
              defaultFees?.data_breach?.default?.toFixed(2) || "0.00"
            }
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"data_breach"}
            name={"data_breach"}
            value={values.data_breach}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.data_breach}
            errored={errors.data_breach}
            error={errors.data_breach}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("data_breach", e.target.rawValue);
              },
            }}
          />

          <TextInput
            label={"Monthly Minimum"}
            placeholder={
              defaultFees?.monthly_minimum?.default?.toFixed(2) || "0.00"
            }
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"monthly_minimum"}
            name={"monthly_minimum"}
            value={values.monthly_minimum}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.monthly_minimum}
            errored={errors.monthly_minimum}
            error={errors.monthly_minimum}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("monthly_minimum", e.target.rawValue);
              },
            }}
          />
          <TextInput
            label={"Semi-Annual Tech Fee"}
            placeholder={
              defaultFees?.semi_annual_tech_fee?.default?.toFixed(2) || "0.00"
            }
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"semi_annual_tech_fee"}
            name={"semi_annual_tech_fee"}
            value={values.semi_annual_tech_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.semi_annual_tech_fee}
            errored={errors.semi_annual_tech_fee}
            error={errors.semi_annual_tech_fee}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("semi_annual_tech_fee", e.target.rawValue);
              },
            }}
          />
          <TextInput
            label={"Voice ARU"}
            placeholder={defaultFees?.voice_aru?.default?.toFixed(2) || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            suffix={"/auth"}
            id={"voice_aru"}
            name={"voice_aru"}
            value={values.voice_aru}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.voice_aru}
            errored={errors.voice_aru}
            error={errors.voice_aru}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("voice_aru", e.target.rawValue);
              },
            }}
          />

          <TextInput
            label={"Batch Fee"}
            placeholder={defaultFees?.batch_fee?.default?.toFixed(2) || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"batch_fee"}
            name={"batch_fee"}
            value={values.batch_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.batch_fee}
            errored={errors.batch_fee}
            error={errors.batch_fee}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("batch_fee", e.target.rawValue);
              },
            }}
          />
          <TextInput
            label={"Returned ACH Item"}
            placeholder={
              defaultFees?.returned_ach_item?.default?.toFixed(2) || "0.00"
            }
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"returned_ach_item"}
            name={"returned_ach_item"}
            value={values.returned_ach_item}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.returned_ach_item}
            errored={errors.returned_ach_item}
            error={errors.returned_ach_item}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("returned_ach_item", e.target.rawValue);
              },
            }}
          />
          <TextInput
            label={"AVS Fee"}
            placeholder={defaultFees?.avs_fee?.default?.toFixed(2) || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            suffix={"/txn"}
            id={"avs_fee"}
            name={"avs_fee"}
            value={values.avs_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.avs_fee}
            errored={errors.avs_fee}
            error={errors.avs_fee}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("avs_fee", e.target.rawValue);
              },
            }}
          />

          <TextInput
            label={"3rd Party Auth/Txn"}
            placeholder={
              defaultFees?.auth_transaction?.default?.toFixed(2) || "0.00"
            }
            type="text"
            inputMode="decimal"
            prefix={"$"}
            suffix={"/txn"}
            id={"auth_transaction"}
            name={"auth_transaction"}
            value={values.auth_transaction}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.auth_transaction}
            errored={errors.auth_transaction}
            error={errors.auth_transaction}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("auth_transaction", e.target.rawValue);
              },
            }}
          />
          <TextInput
            label={"ETF Fee"}
            placeholder={defaultFees?.etf_fee?.default?.toFixed(2) || "0.00"}
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"etf_fee"}
            name={"etf_fee"}
            value={values.etf_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.etf_fee}
            errored={errors.etf_fee}
            error={errors.etf_fee}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("etf_fee", e.target.rawValue);
              },
            }}
          />
          <TextInput
            label={"Chargeback Fee"}
            placeholder={
              defaultFees?.chargeback_fee?.default?.toFixed(2) || "0.00"
            }
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"chargeback_fee"}
            name={"chargeback_fee"}
            value={values.chargeback_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.chargeback_fee}
            errored={errors.chargeback_fee}
            error={errors.chargeback_fee}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("chargeback_fee", e.target.rawValue);
              },
            }}
          />

          <TextInput
            label={"Representment Fee"}
            placeholder={
              defaultFees?.representment_fee?.default?.toFixed(2) || "0.00"
            }
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"representment_fee"}
            name={"representment_fee"}
            value={values.representment_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.representment_fee}
            errored={errors.representment_fee}
            error={errors.representment_fee}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("representment_fee", e.target.rawValue);
              },
            }}
          />
          <TextInput
            label={"Pre-Dispute Fee"}
            placeholder={
              defaultFees?.pre_dispute_fee?.default?.toFixed(2) || "0.00"
            }
            type="text"
            inputMode="decimal"
            prefix={"$"}
            id={"pre_dispute_fee"}
            name={"pre_dispute_fee"}
            value={values.pre_dispute_fee}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched.pre_dispute_fee}
            errored={errors.pre_dispute_fee}
            error={errors.pre_dispute_fee}
            cleaveOptions={{
              numeral: true,
              numeralDecimalScale: 2,
              numeralDecimalMark: ".",
              onValueChanged: (e) => {
                setFieldValue("pre_dispute_fee", e.target.rawValue);
              },
            }}
          />
        </div>
      )}
    </div>
  );
};

export default FeeDefaults;
